import { api, getToken, setToken } from '../utils/apiClient';

export const authService = {
  async login(email, password) {
    const data = await api.post('/auth/login', { email, password });
    setToken(data.token);
    return data;
  },

  async me() {
    return api.get('/auth/me');
  },

  logout() {
    setToken(null);
  },

  isAuthenticated() {
    return !!getToken();
  },
};
